module.exports = __webpack_public_path__ + "media/books/ArtBooks-hero-crop-d50773b6.jpg";